import React from 'react';

import './HiddenSubmitButton.css';

export const HiddenSubmitButton = ({ disabled }) =>
    <button
        className="HiddenSubmitButton"
        type="submit"
        disabled={disabled}
    ></button>;